import GenericAnalogSensor, { defaultGenericAnalogSensor } from './GenericAnalogSensor';

export default interface TemperatureSensor extends GenericAnalogSensor {
  '@type': 'temperature_sensor';
}

const { '@type': _, ...defaultSensorWithoutType } = defaultGenericAnalogSensor;

export const defaultTemperatureSensor: TemperatureSensor = {
  '@type': 'temperature_sensor',
  ...defaultSensorWithoutType,
};
